import { put, select } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    GET_PRODUCT_BRAND_AND_CATEGORY_DATA_SUCCESS,
    GET_PRODUCT_BRAND_AND_CATEGORY_DATA_FAILURE,
} from '../actions';
import { updateIsAllTerritoryId } from 'src/utils/util';

export default function* getCategoryAndBrands() {
    const { territoryId } = yield select((state) => ({
        territoryId: state.surgeryReducer.surgeryDetails.territoryId
    }));
    const { isMastOrder } = yield select((state) => ({
        isMastOrder: state.loginReducer.isMastOrder
    }));
    const { isMastOrderTemplate } = yield select((state) => ({
        isMastOrderTemplate: state.commonTemplateReducer.isMastOrderTemplate
    }));
    const territoryIdValue =  updateIsAllTerritoryId(territoryId);
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/products/productBrandAndCategoryList?territoryId=${encodeURIComponent(territoryIdValue)}&isMastOrder=${encodeURIComponent(isMastOrder || isMastOrderTemplate)}`;
    try {
        const result = yield axios.get(url).then((response) => response.data);
        const updatedData = result?.brandData?.map((item) => {
            return {
                ...item,
                isChecked: false,
            };
        });
        result.brandData = updatedData;
        yield put({
            type: GET_PRODUCT_BRAND_AND_CATEGORY_DATA_SUCCESS,
            categoryAndBrands: result,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url
        });
        yield put({
            type: GET_PRODUCT_BRAND_AND_CATEGORY_DATA_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
